import React from 'react';
import styles from "./FormSeparator.module.scss";
import { Typography } from 'seagull';
export function FormSeparatorHorizontal(props) {
  const {
    children
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.horizontalSeparatorContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.horizontalSeparator
  }), /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary"
  }, children), /*#__PURE__*/React.createElement("div", {
    className: styles.horizontalSeparator
  }));
}
export function FormSeparatorVertical(props) {
  const {
    children
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.verticalSeparatorContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.verticalSeparator
  }), /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary"
  }, children), /*#__PURE__*/React.createElement("div", {
    className: styles.verticalSeparator
  }));
}